import { jsx } from '@theme-ui/core';
import { css, get } from '@theme-ui/css';
import styled from '@emotion/styled';
import { useMDXComponents, MDXProvider as MDXProvider$1 } from '@mdx-js/react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

// mdx components
var tags = ['p', 'b', 'i', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'pre', 'code', 'ol', 'ul', 'li', 'blockquote', 'hr', 'em', 'table', 'tr', 'th', 'td', 'em', 'strong', 'del', // mdx
'inlineCode', 'thematicBreak', // other
'div', // theme-ui
'root'];
var aliases = {
  inlineCode: 'code',
  thematicBreak: 'hr',
  root: 'div'
};

var isAlias = function isAlias(x) {
  return x in aliases;
};

var alias = function alias(n) {
  return isAlias(n) ? aliases[n] : n;
};

var themed = function themed(key) {
  return function (props) {
    return css(get(props.theme, "styles.".concat(key)))(props.theme);
  };
}; // opt out of typechecking whenever `as` prop is used

var Styled = styled('div')(themed('div'));
var components = {};
tags.forEach(function (tag) {
  // fixme?
  components[tag] = styled(alias(tag))(themed(tag));
  Styled[tag] = components[tag];
});

var createComponents = function createComponents(comps) {
  var next = _objectSpread2({}, components);

  var componentKeys = Object.keys(comps);
  componentKeys.forEach(function (key) {
    next[key] = styled(comps[key])(themed(key));
  });
  return next;
};

var MDXProvider = function MDXProvider(_ref) {
  var components = _ref.components,
      children = _ref.children;
  var outer = useMDXComponents();
  return jsx(MDXProvider$1, {
    components: createComponents(_objectSpread2(_objectSpread2({}, outer), components)),
    children: children
  });
};

export { MDXProvider, Styled, components, themed };
